import { getCurrentTheme } from '../../common/themes';

export interface IFetchProfilePoliciesByCategoryIdRes {
  policies: IPolicy[];
}

export enum EPolicyFields {
  id = 'id',
  policyId = 'policyId',
  ruleId = 'ruleId',
  name = 'name',
  catId = 'catId',
  description = 'description',
  detailedDescription = 'detailedDescription',
  severity = 'severity',
  selected = 'selected',
  args = 'args',
  order = 'order',
  notes = 'notes',
  displayIssueSeverity = 'displayIssueSeverity',
}
const currentTheme = getCurrentTheme();
export const ESeverityColors = {
  Appoxalypse: currentTheme.palette.categoryRiskColor['appoxalypse'],
  Critical: currentTheme.palette.categoryRiskColor['critical'],
  High: currentTheme.palette.categoryRiskColor['high'],
  Medium: currentTheme.palette.categoryRiskColor['medium'],
  Low: currentTheme.palette.categoryRiskColor['low'],
  Info: currentTheme.palette.categoryRiskColor['info'],
} as const;
export interface IPolicy {
  [EPolicyFields.id]: string;
  [EPolicyFields.policyId]: string;
  [EPolicyFields.ruleId]?: string;
  [EPolicyFields.name]: string;
  [EPolicyFields.catId]: number;
  [EPolicyFields.description]: string;
  [EPolicyFields.detailedDescription]: string;
  [EPolicyFields.severity]: EPolicySeverity;
  [EPolicyFields.selected]: boolean;
  [EPolicyFields.args]: IArgs[];
  [EPolicyFields.order]: number;
  [EPolicyFields.notes]?: string[];
  [EPolicyFields.displayIssueSeverity]?: EPolicySeverity;
}
export interface IFunction {
  name?: string;
  args: IArgs[];
}

export interface IArgs {
  __typename?: string;
  id: string;
  name: string;
  label: string;
  tooltip: string;
  type: string;
  value: TValue;
  range?: TRange;
  multiSelect?: boolean;
  visible: boolean;
  isDirty?: boolean;
}

export type TArgs = Omit<IArgs, 'type' | 'multiSelect' | 'visible'> & {
  policyId: string;
};

export type TRange = string[] | string | [number, number] | number[];

export type TValue = string[] | number | string | boolean;

export enum EPolicySeverity {
  Appoxalypse = 5,
  Critical = 4,
  High = 3,
  Medium = 2,
  Low = 1,
  Info = 0,
}

export const SEVERITY_LIST = Object.entries(EPolicySeverity).filter(([k]) => {
  return isNaN(Number(k));
});

export const ESeverityColorsList = [
  currentTheme.palette.categoryRiskColor['appoxalypse'],
  currentTheme.palette.categoryRiskColor['critical'],
  currentTheme.palette.categoryRiskColor['high'],
  currentTheme.palette.categoryRiskColor['medium'],
  currentTheme.palette.categoryRiskColor['low'],
  currentTheme.palette.categoryRiskColor['info'],
] as const;

export const SEVERITIES_RANGE_LIST = [
  {
    displyName: 'Appoxalypse Only',
    value: EPolicySeverity.Appoxalypse,
    color: currentTheme.palette.categoryRiskColor['appoxalypse'],
  },
  {
    displyName: 'Critical And Appoxalypse',
    value: EPolicySeverity.Critical,
    color: currentTheme.palette.categoryRiskColor['critical'],
  },
  {
    displyName: 'High Critical And Appoxalypse',
    value: EPolicySeverity.High,
    color: currentTheme.palette.categoryRiskColor['high'],
  },
  {
    displyName: 'Medium And Higher',
    value: EPolicySeverity.Medium,
    color: currentTheme.palette.categoryRiskColor['medium'],
  },
  {
    displyName: 'Low And Higher',
    value: EPolicySeverity.Low,
    color: currentTheme.palette.categoryRiskColor['low'],
  },
  {
    displyName: 'All (Including Info)',
    value: EPolicySeverity.Info,
    color: currentTheme.palette.categoryRiskColor['info'],
  },
] as const;
